import { CurrencyType, ItemType } from '../types';
import { makeCurrencyFormatter, makeItemFormatter } from './utils';
export const formatterCurrency = {
  [CurrencyType.BUSD]: makeCurrencyFormatter({
    symbol: 'BUSD',
    precision: 2
  }),
  [CurrencyType.BUSDT]: makeCurrencyFormatter({
    symbol: 'USDT',
    precision: 2
  }),
  [CurrencyType.THC]: makeCurrencyFormatter({
    symbol: 'THC',
    precision: 2
  }),
  [CurrencyType.THG]: makeCurrencyFormatter({
    symbol: 'THG',
    precision: 2
  }),
  [CurrencyType.WBNB]: makeCurrencyFormatter({
    symbol: 'WBNB',
    precision: 2
  }),
  [CurrencyType.GOLD]: makeCurrencyFormatter({
    symbol: 'GOLD',
    precision: 2
  }),
  [CurrencyType.BNB]: makeCurrencyFormatter({
    symbol: 'BNB',
    precision: 2
  }),
  [CurrencyType.GTHC]: makeCurrencyFormatter({
    symbol: 'THC',
    precision: 2
  }),
  [CurrencyType.GPP]: makeCurrencyFormatter({
    symbol: 'PP',
    precision: 2
  }),
  [CurrencyType.GTHG]: makeCurrencyFormatter({
    symbol: 'THG',
    precision: 2
  }),
  [CurrencyType.GPT]: makeCurrencyFormatter({
    symbol: 'pTicket',
    precision: 2
  }),
  [CurrencyType.GMQP]: makeCurrencyFormatter({
    symbol: 'Quest Point',
    precision: 2
  })
};
export const formatterItem = {
  [ItemType.TOURNAMENT_TICKET]: makeItemFormatter({
    symbol: 'Ticket',
    precision: 0
  })
};